<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
		>
			<el-table-column prop="id" label="ID" width="80px"> </el-table-column>
			<el-table-column prop="title" label="文章标题" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="文章类型" width="80px">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 1">文章</span>
					<span v-if="scope.row.type == 2">快讯</span>
					<span v-if="scope.row.type == 5">专栏</span>
					<span v-if="scope.row.type == 7">活动</span>
				</template>
			</el-table-column>
			<el-table-column
				v-if="type == 1"
				prop="source_type"
				label="来源类型"
				width="120px"
			>
				<template slot-scope="scope">
					{{ getSourceType(scope.row.source_type) }}
				</template>
			</el-table-column>
			<el-table-column prop="nickname" label="作者" width="120px">
			</el-table-column>
			<el-table-column prop="release_time" label="提交时间" width="160px">
			</el-table-column>

			<el-table-column label="审核时间" width="160px">
				<template slot-scope="scope">
					<span v-if="scope.row.examine_type == 2"></span>
					<span v-else>{{ scope.row.examine_time }}</span>
				</template>
			</el-table-column>

			<el-table-column label="审核结果描述" width="220px">
				<template slot-scope="scope">
					<span v-if="scope.row.examine_type == 1">审核通过</span>
					<span v-if="scope.row.examine_type == 2">审核中</span>
					<span v-if="scope.row.examine_type == 3">
						{{
							scope.row.examine_desc != null &&
							scope.row.examine_desc.length > 0
								? scope.row.examine_desc
								: "审核拒绝"
						}}
					</span>
					<span v-if="scope.row.examine_type == 4">草稿</span>
				</template>
			</el-table-column>

			<el-table-column fixed="right" label="预览" width="60px">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="showPreView(scope.row)">
						预览
					</span>
					<!-- <span class="pointer margin_left_10" @click="toDetail(scope.row)">
						详情
					</span> -->
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="150px">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="toExamine(scope.row)">
						审核
					</span>
					<span class="pointer margin_left_10" @click="toEdit(scope.row)">
						编辑
					</span>
					<span class="pointer margin_left_10" @click="toDelete(scope.row)">
						删除
					</span>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog
			class="examine_dialog"
			title="审核操作"
			:visible.sync="examineDialogVisible"
			:append-to-body="true"
		>
			<div class="examine_dialog_content">
				<div class="examine_dialog_item">
					<div class="examine_dialog_item_title">文章标题</div>
					<div class="examine_dialog_item_text">{{ this.row.title }}</div>
				</div>

				<div class="examine_dialog_item">
					<div class="examine_dialog_item_title">作者</div>
					<div class="examine_dialog_item_text">{{ this.row.nickname }}</div>
				</div>

				<div class="examine_dialog_item">
					<div class="examine_dialog_item_title">文章类型</div>
					<div class="examine_dialog_item_text">专栏</div>
				</div>

				<div class="examine_dialog_item">
					<div class="examine_dialog_item_title">提交时间：</div>
					<div class="examine_dialog_item_text">
						{{ this.row.release_time }}
					</div>
				</div>

				<div class="examine_dialog_item examine_dialog_item_1">
					<div class="examine_dialog_item_title">审核结果：</div>
					<div class="examine_dialog_item_text">
						<el-select
							class="custom_input_120"
							v-model="row.examine_type"
							placeholder="请选择"
						>
							<el-option
								v-for="item in examineOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</div>
				</div>

				<div class="examine_dialog_item" v-if="row.examine_type == 3">
					<div class="examine_dialog_item_title">未通过理由:</div>
					<div class="examine_dialog_item_text_input">
						<el-input
							type="textarea"
							v-model="row.examine_desc"
							placeholder="请输入未通过理由"
							:rows="4"
						>
						</el-input>
					</div>
				</div>
				<div class="examine_dialog_item">
					<div class="examine_dialog_item_title">首页显示</div>
					<el-radio v-model="row.is_home" :label="1"> 是 </el-radio>
					<el-radio v-model="row.is_home" :label="0"> 否 </el-radio>
				</div>
				<div>
					<el-button type="primary" @click="submit(row)">
						提交审核结果</el-button
					>
					<el-button @click="cancel()"> 取消</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	addInformation,
	delInformation,
	submitInformation,
} from "@/api/article";
import { status } from "nprogress";
export default {
	props: ["tableData", "type"],
	name: "",
	data() {
		return {
			examineDialogVisible: false,
			examineOptions: [
				{ value: 1, label: "审核通过" },
				{ value: 2, label: "审核中" },
				{ value: 3, label: "审核不通过" },
				{ value: 4, label: "草稿" },
			],
			row: {},
			value: true,
			sourceTypeMap: {
				50: "BlockBeats",
				51: "Odaily",
				52: "Bitpush",
				53: "TechFlow",
				54: "PANews",
				55: "MLion",
				56: "金十",
				57: "Followin",
				15: "OKX",
				16: "Bitget",
				17: "Stock-BBX",
				18: "MyToken",
				40: "BBX",
				10: "BlockBeats",
				11: "TechFlow",
				12: "PANews",
				13: "Bitpush",
				14: "TechFlow Research",
				19: "ChainCatcher",
				20: "BlockTempo",
				21: "吴说",
				22: "MarsBit",
				81: "AIMPACT",
			},
		};
	},
	methods: {
		getSourceType(type) {
			var sourceType = this.sourceTypeMap[type];
			if (!sourceType) {
				sourceType = type;
			}
			return sourceType;
		},
		toExamine(row) {
			if (this.type == 1) {
				this.$confirm("是否审核通过该文章, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						submitInformation({
							id: row.id,
							status: 1,
							is_home: row.is_home,
						}).then((res) => {
							if (res.code == 200) {
								this.$message({
									type: "success",
									message: "审核通过成功!",
								});
								this.$parent.$parent.getDataList();
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消",
						});
					});
			} else {
				this.row = {
					...row,
					examine_desc: row.examine_desc || "",
					is_home: row.is_home != null ? row.is_home : 0,
				};
				this.examineDialogVisible = true;
			}
		},
		toDetail(row) {
			this.$router.push({
				path: "/message/addmessage_new",
				query: { id: row.id, type: "detail" },
			});
		},
		toEdit(row) {
			this.$router.push({
				path: "/message/addmessage_new",
				query: { id: row.id, type: "edit" },
			});
		},

		showPreView(row) {
			let url = "https://me.news/contents/" + row.id;
			window.open(url, "预览");
		},
		cancel() {
			this.examineDialogVisible = false;
			this.row = {};
			this.$parent.$parent.getDataList();
		},

		submit(row) {
			this.examine(
				row.examine_type,
				row,
				row.examine_type == 3 ? row.examine_desc : "",
			);
		},

		toDelete(row) {
			this.$confirm("此操作将删除该条资讯, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					delInformation({ id: row.id }).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.$parent.$parent.getDataList();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		examine(examine_type, row, examine_desc) {
			let that = this;
			let formData = {
				examine_type: examine_type,
				id: row.id,
				examine_desc: examine_desc,
				type: 5,
				score: 1,
				release_time: row.release_time,
				content: row.content,
				source_id: "1024",
				is_home: row.is_home,
			};

			if (examine_type == 1) {
				formData.status = 1;
			}
			addInformation(formData)
				.then((res) => {
					if (res.code == 200) {
						location.reload();
					} else {
					}
				})
				.catch((error) => {});
		},
	},
};
</script>

<style>
.examine_dialog .el-dialog {
	display: block;

	width: 60% !important;

	max-width: 600px !important;
}

.examine_dialog .el-dialog__body {
	/* width: 90%; */
	background: rgba(0, 0, 0, 0);
}
.examine_dialog_content {
	text-align: left;
	margin-left: 20px;
	margin-right: 80px;
}

.examine_dialog_item {
	display: flex;
	margin-bottom: 20px;
	/* align-items: center; */
}

.examine_dialog_item_1 {
	align-items: center;
}

.examine_dialog_item_title {
	font-size: 14px;
	width: 90px;
	font-weight: 700;
	flex-shrink: 0; /* 禁止收缩 */
}

.examine_dialog_item_text {
	font-size: 14px;
	margin-right: 30px;
	font-weight: 700;
}

.examine_dialog_item_text_input {
	width: 80%;
}
</style>
